<template>
  <div class="medal-popup">
    <div class="medal-popup-row text-right mt--2">
      <img class="medal-popup-close" src="@/assets/hometeacher/images/close.png" @click="close">
    </div>
    <div class="medal-popup-row">
      <div class="medal-popup-params">
        <div class="medal-popup-name">{{ medal.name }}</div>
      </div>
      <div class="medal-popup-photo">
        <img v-if="medal.image" :src="`${medal.image}`" :alt="medal.name">
      </div>
    </div>
    <div class="medal-popup-row pt-1">
      <div class="medal-popup-devider"></div>
    </div>
    <div class="medal-popup-row">
      <div class="medal-popup-row medal-popup-description">
        <div class="mb-3"><span class="strong-black">{{ $t('medal_condition') }}</span></div>
        <div>{{ medal.description }}</div>
      </div>
    </div>
    <div class="medal-popup-row" v-if="medal.points > 0">
      <div class="medal-popup-zern">
        <img src="@/assets/hometeacher/images/zern.png" alt="medal.points"><span>{{ medal.points }}</span>
      </div>
    </div>
    <div class="medal-popup-row" v-if="medal.link && medal.link_title">
      <div class="medal-popup-action"><a :href="medal.link" target="_blank">{{  medal.link_title }}</a></div>
    </div>
  </div>
</template>

<script>
export default {
  name: "MedalPopup",
  props: {
    medal: Object,
  },

  methods: {
    close() {
      this.$emit('close')
    },
  }
}
</script>

<style>
.medal-popup-name {
  font-family: "Manrope Bold";
  font-size: 21px;
  line-height: 30px;
  color: #231c37;
  margin-left: 15px;
}

.medal-popup-label, .medal-popup-label-inline {
  font-family: "Manrope Bold";
  color: #231c37;
  font-size: 14px;
}


.medal-popup-value, .medal-popup-value-inline {
  color: #231c37;
  font-size: 14px;
  line-height: 15px;
}

.medal-popup-label-inline, .medal-popup-value-inline {
  display: inline-block;
}

@media (min-width: 767px) {
  .medal-popup {
    width: 352px;
  }
}

.medal-popup {
  z-index: 1;
  position: relative;
  max-width: 100%;
}

.medal-popup-photo img {
  border-radius: 50%;
  box-shadow: 1px 2px 7px 1px rgba(40, 40, 40, 0.5);
  margin-bottom: 15px;
  width: 60px !important;
  height: 60px !important;
  object-fit: cover;
  float: none !important;
  max-width: 100%;
}

.medal-popup-name, .medal-popup-photo {
  display: inline-block;
}

.medal-popup-params {
  width: 79%;
  float: right;
}

.medal-popup-photo {
  text-align: left;
  width: 19%;
}

.medal-popup-param {
  margin-bottom: 15px;
}

.medal-popup-row {
  clear: both;
}

.medal-popup-label-inline {
  margin-right: 5px;
}

.medal-popup-label {
  margin-bottom: 5px;
}

.medal-popup-close {
  cursor: pointer;
}

.medal-popup-devider {
  width: 100%;
  height: 1px;
  background-color: #c4d4da;
  margin-bottom: 15px;
}

.medal-popup-description {
  color: #4f4d5c;
  font-size: 16px;
  line-height: 18px;
  white-space: pre-line;
}

.medal-popup-zern {
  border: 1px solid #f15b22;
  display: inline-block;
  padding: 5px 20px;
  border-radius: 5px;
  margin-top: 20px;
  font-size: 15px;
  font-family: Manrope Bold;
}

.medal-popup-zern img {
  margin-right: 8px;
}

.medal-popup-action a {
  background: #5ab947;
  color: white;
  font-family: Manrope Bold;
  padding: 8px 25px;
  display: inline-block;
  border-radius: 20px;
  margin-top: 25px;
}
</style>
